import React, { useState } from 'react';
export function SignupForm() {
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('');
  const [company, setCompany] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!email.includes('@')) {
      setError('Please enter a valid email address');
      return;
    }
    setIsSubmitting(true);
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSubmitted(true);
    }, 1500);
  };
  if (isSubmitted) {
    return <div className="text-center py-4" data-id="element-21">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-green-50 text-green-500 mb-4" data-id="element-22">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-23">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-24" />
          </svg>
        </div>
        <h3 className="text-xl font-medium text-[#133863] mb-2" data-id="element-25">Thank you!</h3>
        <p className="text-gray-600" data-id="element-26">
          You've been added to our waiting list. We'll be in touch soon.
        </p>
      </div>;
  }
  return <form onSubmit={handleSubmit} className="space-y-4" data-id="element-27">
      {error && <div className="text-red-500 text-sm" data-id="element-28">{error}</div>}
      <div data-id="element-29">
        <label htmlFor="email" className="block text-sm font-medium text-gray-600 mb-1 text-left" data-id="element-30">
          Email
        </label>
        <input type="email" id="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full px-4 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:ring-[#133863] focus:border-[#133863]" placeholder="you@example.com" required data-id="element-31" />
      </div>
      <div data-id="element-32">
        <label htmlFor="role" className="block text-sm font-medium text-gray-600 mb-1 text-left" data-id="element-33">
          Role
        </label>
        <input type="text" id="role" value={role} onChange={e => setRole(e.target.value)} className="w-full px-4 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:ring-[#133863] focus:border-[#133863]" placeholder="Your role or position" data-id="element-34" />
      </div>
      <div data-id="element-35">
        <label htmlFor="company" className="block text-sm font-medium text-gray-600 mb-1 text-left" data-id="element-36">
          Company
        </label>
        <input type="text" id="company" value={company} onChange={e => setCompany(e.target.value)} className="w-full px-4 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:ring-[#133863] focus:border-[#133863]" placeholder="Your company" data-id="element-37" />
      </div>
      <button type="submit" disabled={isSubmitting} className="w-full py-3 px-4 bg-[#133863] hover:bg-[#1d4f8a] text-white font-medium rounded-lg transition-colors duration-300 flex justify-center" data-id="element-38">
        {isSubmitting ? <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-39">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-40"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-41"></path>
          </svg> : 'Join Waiting List'}
      </button>
    </form>;
}